import { z } from 'zod';
import { oneOf } from '../../navigation/searchParams';
import { topupReturnShape } from './topupReturnSearch';

/** The Stripe return signals: back from a top-up checkout, or from the card portal (`portal=payment`). */
export const billingSearch = z.object({
  ...topupReturnShape,
  portal: oneOf(['payment']),
});
